import styled from 'styled-components'

export const MultiselectSelectContainer = styled.div`
  width: 100%;
`

export const multiselectCustomStyles = {
  control: styles => ({ ...styles, backgroundColor: 'white', padding: '.5rem', borderRadius: '10px' }),
  multiValue: styles => {
    return { ...styles, backgroundColor: '#eee', border: '1px solid #ccc', borderRadius: '6px' }
  },
}
